import React from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useAuth } from '../contexts/AuthContext';
import {
  Container,
  Typography,
  Grid,
  Box,
  Tabs,
  Tab,
  Alert,
  CircularProgress,
} from '@mui/material';
import { apiWithAuth } from '../services/api';
import ApplicationCard from '../components/applications/ApplicationCard';

const Applications = () => {
  const [tabValue, setTabValue] = React.useState(0);
  const { currentUser } = useAuth();
  const history = useHistory();

  const { data: applications = [], isLoading, error } = useQuery(
    'applications',
    async () => {
      const token = localStorage.getItem('token');
      const response = await apiWithAuth(token).get('/applications/');
      return response.data;
    },
    {
      refetchInterval: 30000, // Refetch every 30 seconds to catch status updates
    }
  );

  // Redirect organizers away from this page
  if (currentUser && currentUser.role_id === 2) {
    history.replace('/dashboard');
    return null;
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Organizer-only actions removed for vendor view

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }
  if (error) return <Alert severity="error">{error.message}</Alert>;

  const filteredApplications = applications?.filter((app) => {
    const status = app.status?.toLowerCase();
    const paymentStatus = app.payment_status?.toLowerCase();
    
    if (tabValue === 0) {
      // Pending: status is pending and not waitlisted
      return status === 'pending' && 
             status !== 'waitlist' &&
             (app.waitlist_position === null || app.waitlist_position === undefined);
    }
    if (tabValue === 1) {
      // Accepted: status is accepted/approved but payment is NOT confirmed
      return (status === 'accepted' || status === 'approved') && 
             paymentStatus !== 'confirmed';
    }
    if (tabValue === 2) {
      // Confirmed: status is confirmed/confirm-payment OR (accepted/approved AND payment confirmed)
      return (status === 'confirmed' || status === 'confirm-payment') ||
             ((status === 'accepted' || status === 'approved') && paymentStatus === 'confirmed');
    }
    // Rejected (tabValue === 3)
    return status === 'rejected';
  });

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        My Applications
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label="Pending" />
          <Tab label="Accepted" />
          <Tab label="Confirmed" />
          <Tab label="Rejected" />
        </Tabs>
      </Box>

      <Grid container spacing={3}>
        {filteredApplications?.map((application) => (
          <Grid item xs={12} md={6} key={application.application_id}>
            <ApplicationCard
              application={application}
              isOrganizer={false}
              showActions={false}
            />
          </Grid>
        ))}

        {filteredApplications?.length === 0 && (
          <Grid item xs={12}>
            <Alert severity="info">
              No {tabValue === 0 ? 'pending' : tabValue === 1 ? 'accepted' : tabValue === 2 ? 'confirmed' : 'rejected'} applications found.
            </Alert>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default Applications; 